var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetupLiveScreen = function SvgSetupLiveScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 29
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 26,
    fill: "currentColor",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.236 38.01c-1.333-1.329-1.347-3.268.157-4.604 1.527-1.365 4.292-2.823 6.262-4.791 1.42-1.416-.43-3.887 2.179-6.372 1.79-1.71 4.771-1.66 6.555.173.409.409.674.933.781 1.307l-2.887.826c-.566.165-.788.596-.652 1.113l1.247 4.583c-1.627.654-2.96-.029-4.142 1.156-1.963 1.969-3.797 5.15-4.908 6.444-1.303 1.53-3.267 1.494-4.592.165m14.623-8.282-.91-3.376c.165.021.323.007.523-.05l2.193-.633c.28 1.142-.144 2.479-1.04 3.398-.25.259-.508.481-.766.66m-5.495-2.794 1.605-.424c.15-.043.258-.194.2-.352a.284.284 0 0 0-.336-.194l-1.62.43c-.15.044-.243.202-.2.339.043.165.186.244.35.2m.2.826 1.612-.424a.28.28 0 0 0 .194-.352c-.05-.15-.194-.23-.33-.194l-1.626.431c-.15.043-.244.201-.2.338.057.165.193.244.35.2m.208.826 1.62-.438a.285.285 0 0 0 .193-.345c-.036-.144-.18-.23-.337-.187l-1.626.431a.29.29 0 0 0-.2.338.28.28 0 0 0 .35.2m-7.258 7.966a.822.822 0 0 0 0-1.645.83.83 0 0 0-.824.826c0 .445.373.819.824.819"
  })));
};
export default SvgSetupLiveScreen;